import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContentPreviewPaneComponent} from './content-preview-pane.component';
import {FormsModule} from '@angular/forms';
import {SendTestEmailModule} from '../project/emailTest/send-test-email.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SendTestEmailModule
    ],
    declarations: [ContentPreviewPaneComponent],
    providers: [],
    exports: [ContentPreviewPaneComponent]
})
export class ContentPreviewPaneModule {}
